import router from './router'
import session from './utils/session'
import { Message } from 'element-ui'
const whiteList = [
  '/',
  '/myInformation/myInfo',
  '/personalityStudy/dayReport',
  '/personalityStudy/reportPage',
  '/personalityStudy/reportAllPage',
  '/evaluationReport/reportSum',
  '/evaluationReport/reportDay',
  '/englishItem/reportDetail',
  '/englishItem/enPlanDetail',
  '/englishItem/wordAssReport',
  '/promoteMain/promoteReport',
  '/promoteMain/promoteReportPro',
  '/promoteMain/selfReport',
  '/promoteMain/truePaperReport',
  '/promoteMain/paperReport',
  '/promoteMain/wrongReport',
  '/promoteMain/hWorkReport',
  '/promoteMain/classWrongReport',
  '/homeWork/pointsReport',
  '/homeWork/kpointReport',
  '/homeWork/unitReport',
  '/homeWork/problemReport',
  '/whiteList/dailySummaryReport',
  '/whiteList/videoPage',
  '/workTool/plandReport',
  '/workTool/planLearningReport',
  '/workTool/classExamReport',
  '/workTool/analysisDayReport',
  '/workTool/classBeReport',
  '/workTool/classmanageReport',
  '/myTask/listeningReport',
  '/myTask/specialReport',
  '/myTask/bdcReport',
  '/englishItem/listenReportDe',
  '/myTask/previewReport',
  '/myTask/handReport',
  '/synchronousExercises/synchronousReport',
  '/synchronousExercises/newPreviewReport',
  '/myTask/aiTopic',
  '/myTask/newPreviewTaskReport',
  '/promoteMain/academicReport',
  '/promoteMain/enLearnReport'
]

router.beforeEach((to, from, next) => {
  // 白名单路由直接放行
  if (whiteList.indexOf(to.path) !== -1) {
    return next()
  }
  // 非白名单路由，检查登录状态
  const userInfo = session.get('currentUserInfo')
  if (userInfo && userInfo.endTime) {
    const nowTime = new Date().getTime()
    const EndTime = new Date(userInfo.endTime.replace(/\-/g, '/'))
    if (nowTime <= EndTime) {
      return next()
    }
  }
  // 未登录或已过期，跳转登录页
  session.clear()
  Message.error('登录信息失效，请重新登录')
  return next(`/?redirect=${to.path}`)
})
